<script lang="ts">
	import { Tooltip } from "flowbite-svelte";
	import { createEventDispatcher } from "svelte";
	import type { Field } from "#gen/forms/v1/field_pb.js";
	import Checkbox from "#lib/components/Checkbox.svelte";
	import Icon from "#lib/components/Icon.svelte";
	import DescriptionInput from "#lib/components/page/components/form/DescriptionInput.svelte";
	import type { TypeIcon } from "#lib/components/page/components/form/FieldProps.js";
	import TitleInput from "#lib/components/page/components/form/TitleInput.svelte";

	interface $$Events {
		input: CustomEvent<Field>;
		change: CustomEvent<Field>;
	}

	const dispatch = createEventDispatcher();

	export let typeIcon: TypeIcon | undefined;
	export let field: Field;
	export let active = false;

	function handleRequiredChange(e: Event) {
		const target = e.target as HTMLInputElement;
		field.required = target.checked;
		handleChange();
	}

	function handleReadOnlyChange(e: Event) {
		const target = e.target as HTMLInputElement;
		field.static = target.checked;
		handleChange();
	}

	function handleInput() {
		dispatch("input", field);
	}

	function handleChange() {
		dispatch("change", field);
	}
</script>

<div class="group/field-header flex items-start gap-3 pb-3" class:items-center={field.immutable && !field.description}>
	{#if typeIcon}
		<div class="rounded-lg p-2 text-center" style="background-color: {typeIcon.accentColor};">
			<Icon name={typeIcon.icon} iconSet={typeIcon.iconSet} class="m-auto h-5 w-5" />
			<Tooltip placement="top" class="z-10">{typeIcon.title}</Tooltip>
		</div>
	{/if}
	<div class="flex grow flex-col">
		{#if !field.immutable}
			<div>
				<TitleInput bind:value={field.title} name={field.name} required={field.required} onChange={handleInput} onCommit={handleChange} />
			</div>
			<DescriptionInput bind:value={field.description} onChange={handleInput} onCommit={handleChange} />
		{:else}
			<label for={field.name} class="inline-block text-sm font-medium" class:required={field.required}>
				{field.title}
			</label>
			{#if field.description}
				<div class="field-description my-2 text-xs text-gray-500">{field.description}</div>
			{/if}
		{/if}
	</div>
	<div class="flex flex-none gap-4 opacity-0 group-hover/field-header:opacity-100" class:!opacity-100={active}>
		<Checkbox checked={field.required} disabled={field.immutable} on:click={handleRequiredChange} data-action-name="form-field-required-checkbox">Required</Checkbox>
		<Checkbox checked={field.static} disabled={field.immutable} on:click={handleReadOnlyChange} data-action-name="form-field-readonly-checkbox">Read only</Checkbox>
	</div>
</div>
